import { setAuthStateSubscriber } from '@agentic-flow-studio/shared/components/layout/AppShell';
import { configureRecentPages } from '@agentic-flow-studio/shared/lib/recent-pages-store';
import { setAuthTokenGetter } from '@agentic-flow-studio/shared/lib/trpc';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { betterAuthStateSubscriber, getBetterAuthToken } from './utils/betterAuth';

setAuthTokenGetter(getBetterAuthToken);
setAuthStateSubscriber(betterAuthStateSubscriber);
configureRecentPages('job-plan-portal');

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
